export function iconsAnimations() {
	const $window = $(window);
	const $items = $(".info-items");
	const $graphs = $(".accordion .graph");
	const isIE = !!document.documentMode;
	const isEdge = !isIE && !!window.StyleMedia;


	$window.on("scroll load", () => {
		if (window.innerWidth >= 1200) {
			if (!(isIE || isEdge)) {
				$items.each((i, item) => {
					$(item).find('.icon').each((i, item) => {

						if ($(item).data("json")) {
							$(item).find("img").hide();
						}
					});
					if ($window.scrollTop() > $(item).offset().top - $window.height() * .85 && !$(item).hasClass("animate")) {
						$(item).addClass("animate");
						$(item).find('.icon').each((i, item) => {
							let src = item.getAttribute("data-json");
							if (src) {
								window.lottiejs.loadAnimation({
									container: item,
									path: src,
									renderer: "svg"
								});
							}
						});
					}
				});
			}
		}
		if (window.innerWidth >= 1200) {
			if (!(isIE || isEdge)) {
				$graphs.each((i, item) => {
					if ($(item).data("json")) {
						$(item).find("img").hide()
					}
					if ($window.scrollTop() > $(item).offset().top - $window.height() * .85 && !$(item).hasClass("animate")) {
						$(item).addClass("animate");
						let src = item.getAttribute("data-json");
						if (src) {
							window.lottiejs.loadAnimation({
								container: item,
								path: src,
								renderer: "svg"
							});
						}
					}
				});
			}
		}
	});
}


// WEBPACK FOOTER //
// ./assets/js/modules/iconsAnimations.js